import React from "react";

const SITE = "https://flexlines.store";

const Ld = ({ data }) => (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
);

export function OrganizationSchema() {
    const data = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "FlexLine Mobile",
        alternateName: "Flex Line",
        url: SITE,
        logo: `${SITE}/flexline-logo.svg`,
        description:
            "FlexLine Mobile is a wireless carrier built on eSIM — unlimited talk & text with fast mobile data, activated in minutes. Keep your number or get a new one.",
        email: "info@flexlines.store",
        telephone: "+1-877-738-0943",
        sameAs: [],
        contactPoint: {
            "@type": "ContactPoint",
            telephone: "+1-877-738-0943",
            contactType: "customer service",
            email: "info@flexlines.store",
            areaServed: "US",
            availableLanguage: "English",
        },
    };
    return <Ld data={data} />;
}

export function WirelessOffersSchema({ plans = [] }) {
    if (!plans.length) return null;
    const data = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: "FlexLine Mobile Wireless Plans",
        description:
            "eSIM wireless plans with unlimited talk & text and fast mobile data. No contract, cancel anytime.",
        brand: { "@type": "Brand", name: "FlexLine Mobile" },
        offers: plans.map((p) => ({
            "@type": "Offer",
            name: p.name,
            price: (p.price ?? p.monthly_price ?? 0).toString(),
            priceCurrency: "USD",
            priceSpecification: {
                "@type": "UnitPriceSpecification",
                price: (p.price ?? p.monthly_price ?? 0).toString(),
                priceCurrency: "USD",
                billingIncrement: 1,
                unitCode: "MON",
            },
            availability: "https://schema.org/InStock",
            url: `${SITE}/mobile`,
        })),
    };
    return <Ld data={data} />;
}

export function FaqSchema({ items = [] }) {
    if (!items.length) return null;
    const data = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: items.map((it) => ({
            "@type": "Question",
            name: it.q,
            acceptedAnswer: { "@type": "Answer", text: it.a },
        })),
    };
    return <Ld data={data} />;
}

export const WIRELESS_FAQ = [
    { q: "What is FlexLine Mobile?", a: "FlexLine Mobile is a wireless carrier built entirely on eSIM. You get unlimited talk & text with fast mobile data, activated in minutes — no store visit and no physical SIM card." },
    { q: "Can I keep my current phone number?", a: "Yes. You can port (transfer) your existing number to FlexLine Mobile for free, or choose a brand-new number. Your old service keeps working until the transfer completes." },
    { q: "How do I activate my plan?", a: "After you pick a plan, we issue an eSIM instantly. Just scan the QR code with your phone to install it — most customers are up and running in a few minutes." },
    { q: "Is there a contract?", a: "No. FlexLine Mobile is month-to-month with no contract. Cancel anytime." },
    { q: "How much do plans cost?", a: "Wireless plans start at $19.99/month for unlimited talk & text with mobile data. No contract." },
];
